<template>
  <div class="container">
    <div v-if="pageLoading" class="empty-wrap">
      <a-spin size="large" />
    </div>
    <div v-else-if="!!isEmptyPage" class="empty-wrap">
      <a-empty :description="isEmptyPage" />
    </div>
    <template v-else-if="!!reportData">
      <div class="report-page" id="screen">
        <PageCover
          v-if="requestSuccessedMap.reportData"
          :common-lang="commonLang"
          :module-data="reportData.module1"
        />
        <PageBlock1
          v-if="requestSuccessedMap.reportData"
          :module-data="reportData.module4"
        />
        <Page1
          page-num="01"
          v-if="requestSuccessedMap.reportData"
          :common-lang="commonLang"
          :module-data="reportData.module1_1"
          :report-customization="reportCustomization"
        />
        <Page2
          page-num="02"
          v-if="requestSuccessedMap.reportData"
          :common-lang="commonLang"
          :module-data="reportData.module5"
          :cat-data="page2PoiData"
          :poi-data="newPoiData"
          :report-customization="reportCustomization"
          :yfhw-data="yfhwTotalData"
        />
        <Page3
          page-num="03"
          v-if="requestSuccessedMap.page3"
          :common-lang="commonLang"
          :module-data="reportData.module5"
          :cat-data="page3PoiData"
          :city-info="reportData.module1"
          :poi-data="newPoiData"
          :report-customization="reportCustomization"
        />
        <Page4
          page-num="04"
          v-if="requestSuccessedMap.page4"
          :common-lang="commonLang"
          :module-data="reportData.module6"
          :cat-data="page4And5PoiData"
          :city-info="reportData.module1"
          :report-customization="reportCustomization"
        />
        <Page5
          page-num="05"
          v-if="requestSuccessedMap.page5"
          :common-lang="commonLang"
          :module-data="reportData.module6"
          :cat-data="page4And5PoiData"
          :report-customization="reportCustomization"
        />
        <Page6
          page-num="06"
          v-if="requestSuccessedMap.page6"
          :common-lang="commonLang"
          :city-info="reportData.module1"
          :module-data="reportData.module7"
          :cat-data="page6And7PoiData"
          :report-customization="reportCustomization"
        />
        <Page7
          page-num="07"
          v-if="requestSuccessedMap.page7"
          :common-lang="commonLang"
          :module-data="reportData.module7"
          :cat-data="page6And7PoiData"
          :report-customization="reportCustomization"
        />
        <Page8
          page-num="08"
          v-if="requestSuccessedMap.page8"
          :common-lang="commonLang"
          :module-data="reportData.module8"
          :cat-data1="page8PoiData1"
          :cat-data2="page8PoiData2"
          :city-info="reportData.module1"
          :report-customization="reportCustomization"
        />
        <Page9
          page-num="09"
          v-if="requestSuccessedMap.page9"
          :common-lang="commonLang"
          :module-data="reportData.module8"
          :city-info="reportData.module1"
          :cat-data1="page9PoiData1"
          :cat-data2="page9PoiData2"
          :report-customization="reportCustomization"
        />
      </div>
      <div class="report-page" id="screen2">
        <Page10
          page-num="10"
          v-if="requestSuccessedMap.page10"
          :common-lang="commonLang"
          :module-data="reportData.module9"
          :city-info="reportData.module1"
          :cat-data="page10PoiData"
          :report-customization="reportCustomization"
        />
        <Page11
          page-num="11"
          v-if="requestSuccessedMap.page11"
          :common-lang="commonLang"
          :module-data="reportData.module10"
          :city-info="reportData.module1"
          :cat-data="page11PoiData"
          :poi-data="newPoiData"
          :report-customization="reportCustomization"
        />
        <Page12
          page-num="12"
          v-if="requestSuccessedMap.page12"
          :common-lang="commonLang"
          :city-info="reportData.module1"
          :module-data="reportData.module11"
          :cat-data="page12PoiData"
          :poi-data="newPoiData"
          :report-customization="reportCustomization"
        />
        <Page13
          page-num="13"
          v-if="requestSuccessedMap.page13"
          :common-lang="commonLang"
          :module-data="reportData.module12"
          :city-info="reportData.module1"
          :cat-data="page13PoiData"
          :poi-data="newPoiData"
          :report-customization="reportCustomization"
        />
        <Page14
          page-num="14"
          v-if="requestSuccessedMap.page14"
          :common-lang="commonLang"
          :module-data="reportData.module16"
          :city-info="reportData.module1"
          :cat-data="page14PoiData"
          :report-customization="reportCustomization"
        />
        <Page15
          page-num="15"
          v-if="requestSuccessedMap.page15"
          :common-lang="commonLang"
          :module-data="reportData.module13"
          :city-info="reportData.module1"
          :cat-data="page15PoiData"
          :poi-data="newPoiData"
          :report-customization="reportCustomization"
        />

        <YFHWPage16
          v-if="isYFHW && !!yfhwTotalData"
          page-num="16"
          :common-lang="commonLang"
          :module-data="reportData.module17"
          :report-customization="reportCustomization"
          :yfhw-data="yfhwTotalData"
        />
        <YFHWPage17
          v-if="isYFHW && !!yfhwTotalData"
          page-num="17"
          :common-lang="commonLang"
          :module-data="reportData.module18"
          :report-customization="reportCustomization"
          :yfhw-data="yfhwTotalData"
        />
        <YFHWPage18
          v-if="isYFHW && !!yfhwTotalData"
          page-num="18"
          :common-lang="commonLang"
          :module-data="reportData.module18"
          :report-customization="reportCustomization"
          :yfhw-data="yfhwTotalData"
        />

        <template
          v-if="
            requestSuccessedMap.reportData &&
            !reportData?.module1?.is_province_directly
          "
        >
          <PageBlock2
            :module-data="reportData.module2"
          />
          <Page16
            :page-num="`${diffPageNum+16}`"
            :common-lang="commonLang"
            :module-data="reportData.module3"
            :report-customization="reportCustomization"
          />
          <Page17
            :page-num="`${diffPageNum+17}`"
            v-if="requestSuccessedMap.page17"
            :common-lang="commonLang"
            :city-info="reportData.module1"
            :module-data="reportData.module3"
            :cat-data="page17PoiData"
            :detail-data="page17DetailData"
            :report-customization="reportCustomization"
          />
          <Page18
            :page-num="`${diffPageNum+18}`"
            :common-lang="commonLang"
            :module-data="reportData.module3"
            :report-customization="reportCustomization"
          />
          <Page19
            :page-num="`${diffPageNum+19}`"
            :common-lang="commonLang"
            :module-data="reportData.module3"
            :report-customization="reportCustomization"
          />
        </template>
        <!-- <Page20
          v-if="requestSuccessedMap.page21"
          :module-data="reportData.module14"
          :cat-data="page21Data"
        />
        <Page21
          v-if="requestSuccessedMap.page22 "
          :module-data="reportData.module14"
          :cat-data="page21Data"
        />
        <Page22
          v-if="requestSuccessedMap.page23"
          :module-data="reportData.module14"
          :cat-data="page21Data"
        /> -->
        <PageEnd
          v-if="!isYFHW"
          :module-data="reportData.module15"
          :bottom-logo="reportCustomization.bottomLogo"
        />
      </div>
    </template>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import PageCover from "./PageCover";
import PageBlock1 from "./PageBlock1";

import PageBlock2 from "./PageBlock2";
import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";
import Page5 from "./Page5";
import Page6 from "./Page6";
import Page7 from "./Page7";
import Page8 from "./Page8";
import Page9 from "./Page9";
import Page10 from "./Page10";
import Page11 from "./Page11";
import Page12 from "./Page12";
import Page13 from "./Page13";
import Page14 from "./Page14";
import Page15 from "./Page15";
import Page16 from "./Page16";
import Page17 from "./Page17";
import Page18 from "./Page18";
import Page19 from "./Page19";
import PageEnd from "./PageEnd";

// 远方好物定制
import YFHWPage16 from './YFHWPage16.vue'
import YFHWPage17 from './YFHWPage17.vue'
import YFHWPage18 from './YFHWPage18.vue'

import {
  getReport,
  getPoiData,
  getMarketPoiData,
  getCityAroundDataV2,
  getCityDetailData,
  getCatData,
  getBrandData,
} from "@/api/apiv2";
import {
  getBfhwDataById,
} from '@/api/api-bfhw'

defineProps({
  transform: String,
});

const route = useRoute();
const address_id = route.query.address_id;

// 记录请求记录，使用对象设置每页是否允许加载开关
const requestSuccessedMap = ref({
  reportData: false,
  page3: false,
  page4: false,
  page5: false,
  page6: false,
  page7: false,
  page8: false,
  page9: false,
  page10: false,
  page11: false,
  page12: false,
  page13: false,
  page14: false,
  page15: false,
  page17: false,
  page21: false,
  page22: false,
  page23: false,
});
// 设置请求成功方法
const setRequestSuccessed = (key) => {
  requestSuccessedMap.value[key] = true;
};
// 报告基础数据
const reportData = ref();
const reportCustomization = ref({
  pageLogo: "",
  bottomLogo: "",
  showWater: true,
  showDataSource: true,
});
const pageLoading = ref(true)
// 空数据
const isEmptyPage = ref("");
// 语言
const commonLang = ref('zh')
// 远方好物定制需求
const isYFHW = ref(false)
const diffPageNum = ref(0)
const yfhwTotalData = ref()

/**
 * catIds 每页所需要的catids
 * catData 定义每页需要的数据格式
 * getPage 获取每页需要的数据
 * 数据调用成功会更新请求成功状态true 开始加载页面，地图必须等待数据成功后才能加载
 */

// page2/11数据
const page2Types = [
  ["P020101", "P020201", "P020301", "P020401", "P020501"],
  [
    "P030101",
    "P030201",
    "P030301",
    "P030401",
    "P030501",
    "P030601",
    "P030701",
  ],
  ["P060100", "P060200", "P060300"],
  ["P040100", "P040200", "P040300", "P040400", "P040500", "P040600"],
];
const page2PoiData = ref([[], [], [], []]);
const page11PoiData = ref([]);
const newPoiData = ref({});
function getPage2(res, lang) {
  // page2
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page2Types[0],
    polygon: res.data.module1.polygon || "",
    showPoiList: false,
    resultLanguage: lang,
  }).then((page8res) => {
    page2PoiData.value[0] = page2Types[0]
      .map((v) => {
        return page8res.data.find((d) => d.bhProType === v);
      })
      .filter((v) => !!v.count);
  });
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page2Types[1],
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((page8res) => {
    page2PoiData.value[1] = page2Types[1].map((v) => {
      return page8res.data.find((d) => d.bhProType === v);
    }).filter((v) => !!v.count);
    page11PoiData.value = page8res.data;
    setRequestSuccessed("page11");
  });
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page2Types[2],
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((page8res) => {
    page2PoiData.value[2] = page2Types[2]
      .map((v) => {
        return page8res.data.find((d) => d.bhProType === v);
      })
      .filter((v) => !!v.count);
  });
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page2Types[3],
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((page8res) => {
    page2PoiData.value[3] = page2Types[3]
      .map((v) => {
        return page8res.data.find((d) => d.bhProType === v);
      }).filter((v) => !!v.count);
  });

  // poi改版新数据
  getCityAroundDataV2({
    addressId: address_id,
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    polygon: res.data.module1.polygon || "",
  })
    .then((res) => {
      const data = res?.data || {};
      newPoiData.value = { ...data };
    })
    .catch(() => {
      getCityAroundDataV2({
        addressId: address_id,
        location: res.data.module1.location,
        radius: res.data.module1.radius,
        polygon: res.data.module1.polygon || "",
      })
        .then((res) => {
          const data = res?.data || {};
          newPoiData.value = { ...data };
        })
        .catch(() => {});
    });
}

// page3数据
const page3Types = ["P050101", "P050201", "P050301", "P050401", "P050601"];
const page3PoiData = ref([]);
function getPage3(res, lang) {
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page3Types,
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((res) => {
    page3PoiData.value = res.data;
    setRequestSuccessed('page3');
  }).catch(() => {
    getCatData({
      location: res.data.module1.location,
      radius: res.data.module1.radius,
      bhProType: page9Types,
    }).then((res) => {
      page3PoiData.value = res.data;
      setRequestSuccessed('page3');
    }).catch(() => {
      setRequestSuccessed("page3");
    });
  });
}

// 新poi page4 ｜ page5 使用同样的数据
const page4And5Types = ["P010101"];
const page4And5PoiData = ref({
  count: 0,
  poi: [],
});
function getPage4(res, lang) {
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page4And5Types,
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((res) => {
    page4And5PoiData.value = res?.data[0] || {
      count: 0,
      poi: [],
    };
    setRequestSuccessed('page4');
    setRequestSuccessed('page5');
  }).catch(() => {
    getPoiData({
      location: res.data.module1.location,
      radius: res.data.module1.radius,
      bhProType: page10And11Types,
      polygon: res.data.module1.polygon || "",
      resultLanguage: lang,
    }).then((res) => {
      page4And5PoiData.value = res?.data[0] || {
        count: 0,
        poi: [],
      };
      setRequestSuccessed("page4");
      setRequestSuccessed("page5");
    }).catch(() => {
      setRequestSuccessed("page4");
      setRequestSuccessed("page5");
    });
  });
}

// 新poi page6 ｜ page7 使用同样的数据
const page6And7Types = ["P010201"];
const page6And7PoiData = ref({
  count: 0,
  poi: [],
});
function getPage6(res, lang) {
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page6And7Types,
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((res) => {
    page6And7PoiData.value = res?.data[0] || {
      count: 0,
      poi: [],
    };
    setRequestSuccessed("page6");
    setRequestSuccessed("page7");
  }).catch(() => {
    getPoiData({
      location: res.data.module1.location,
      radius: res.data.module1.radius,
      bhProType: page6And7Types,
      polygon: res.data.module1.polygon || "",
      resultLanguage: lang,
    }).then((res) => {
      page6And7PoiData.value = res?.data[0] || {
        count: 0,
        poi: [],
      };
      setRequestSuccessed("page6");
      setRequestSuccessed("page7");
    }).catch(() => {
      setRequestSuccessed("page6");
      setRequestSuccessed("page7");
    });
  });
}

// page8 ｜ page9 数据
const page8Types = ["P040101", "P040201", "P040301", "P040401", "P040501"];
const page8PoiData1 = ref({
  poi: [],
});
const page8PoiData2 = ref({
  poi: [],
});
const page9PoiData1 = ref({
  poi: [],
});
const page9PoiData2 = ref({
  poi: [],
});
function getPage8(res, lang) {
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page8Types,
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((pageRes) => {
    page8PoiData1.value = pageRes.data.find(
      (el) => el.bhProType === page8Types[0]
    ) || { poi: [] };
    page8PoiData2.value = pageRes.data.find(
      (el) => el.bhProType === page8Types[1]
    ) || { poi: [] };
    page9PoiData1.value = pageRes.data.find(
      (el) => el.bhProType === page8Types[2]
    ) || { poi: [] };
    // 高等院校需要组合两个不同的数据
    const data1 = pageRes.data.find(
      (el) => el.bhProType === page8Types[3]
    ) || { poi: [] };
    const data2 = pageRes.data.find(
      (el) => el.bhProType === page8Types[4]
    ) || { poi: [] };
    page9PoiData2.value = {
      count: (data1?.count || 0) + (data2?.count || 0),
      poi: [].concat(data1?.poi || [], data2?.poi || []),
    };
    setRequestSuccessed("page8");
    setRequestSuccessed("page9");
  }).catch(() => {
    getPoiData({
      location: res.data.module1.location,
      radius: res.data.module1.radius,
      bhProType: page8Types,
      polygon: res.data.module1.polygon || "",
      resultLanguage: lang,
    }).then((pageRes) => {
      page8PoiData1.value = pageRes.data.find(
        (el) => el.bhProType === page8Types[0]
      ) || { poi: [] };
      page8PoiData2.value = pageRes.data.find(
        (el) => el.bhProType === page8Types[1]
      ) || { poi: [] };
      page9PoiData1.value = pageRes.data.find(
        (el) => el.bhProType === page8Types[2]
      ) || { poi: [] };
      // 高等院校需要组合两个不同的数据
      const data1 = pageRes.data.find(
        (el) => el.bhProType === page8Types[3]
      ) || { poi: [] };
      const data2 = pageRes.data.find(
        (el) => el.bhProType === page8Types[4]
      ) || { poi: [] };
      page9PoiData2.value = {
        count: (data1?.count || 0) + (data2?.count || 0),
        poi: [].concat(data1?.poi || [], data2?.poi || []),
      };
      setRequestSuccessed("page8");
      setRequestSuccessed("page9");
    }).catch(() => {
      setRequestSuccessed("page8");
      setRequestSuccessed("page9");
    });
  });
}

// page10数据
const page10PoiData = ref([]);
function getPage10(res, lang) {
  getMarketPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: [],
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  })
    .then((pageRes) => {
      page10PoiData.value = pageRes?.data || [];
      setRequestSuccessed("page10");
    })
    .catch(() => {
      getMarketPoiData({
        location: res.data.module1.location,
        radius: res.data.module1.radius,
        bhProType: [],
        polygon: res.data.module1.polygon || "",
        resultLanguage,
      })
        .then((pageRes) => {
          page10PoiData.value = pageRes?.data || [];
          setRequestSuccessed("page10");
        })
        .catch(() => {
          setRequestSuccessed("page10");
        });
    });
}

// page12数据
const page12Types = [
  "P070100",
  "P070200",
  "P070300",
  "P070400",
  "P070500",
  "P070600",
  "P070700",
  "P070800",
  "P070900",
  "P071000",
  "P071100",
  "P071200",
  "P071300",
];
const page12PoiData = ref([]);
function getPage12(res, lang) {
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page12Types,
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((pageRes) => {
    page12PoiData.value = pageRes?.data.filter((d) => !!d.count) || [];
    setRequestSuccessed("page12");
  }).catch(() => {
    getPoiData({
      location: res.data.module1.location,
      radius: res.data.module1.radius,
      bhProType: page12Types,
      polygon: res.data.module1.polygon || "",
      resultLanguage: lang,
    }).then((pageRes) => {
      page12PoiData.value =
        pageRes?.data.filter((d) => !!d.count) || [];
      setRequestSuccessed("page12");
    }).catch(() => {
      setRequestSuccessed("page12");
    });
  });
}

// page13数据
const page13Types = [
  "P080201",
  "P080401",
  "P080501",
  "P080101",
  "P080801",
  "P080901",
  "P081001",
  "P081301",
];
const page13PoiData = ref([]);
function getPage13(res, lang) {
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page13Types,
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((pageRes) => {
    page13PoiData.value = pageRes?.data.filter((d) => !!d.count) || [];
    setRequestSuccessed("page13");
  }).catch(() => {
    getPoiData({
      location: res.data.module1.location,
      radius: res.data.module1.radius,
      bhProType: page13Types,
      polygon: res.data.module1.polygon || "",
      resultLanguage: lang,
    }).then((pageRes) => {
      page13PoiData.value =
        pageRes?.data.filter((d) => !!d.count) || [];
      setRequestSuccessed("page13");
    }).catch(() => {
      setRequestSuccessed("page13");
    });
  });
}

// page14数据
const page14Types = [
  "P100201",
  "P100203",
  "P100202",
  "P100204",
  "P100205",
  "P100206",
];
const page14PoiData = ref([]);
function getPage14(res, lang) {
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page14Types,
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((pageRes) => {
    page14PoiData.value = pageRes?.data.filter((d) => !!d.count) || [];
    setRequestSuccessed("page14");
  }).catch(() => {
    getPoiData({
      location: res.data.module1.location,
      radius: res.data.module1.radius,
      bhProType: page14Types,
      polygon: res.data.module1.polygon || "",
      resultLanguage: lang,
    }).then((pageRes) => {
      page13PoiData.value =
        pageRes?.data.filter((d) => !!d.count) || [];
      setRequestSuccessed("page14");
    }).catch(() => {
      setRequestSuccessed("page14");
    });
  });
}

// page15数据
const page15Types = [
  "P110101",
  "P110201",
  "P110301",
  "P110401",
  "P110501",
  "P110601",
  "P111001",
  "P111101",
  "P111201",
];
const page15PoiData = ref([]);
function getPage15(res, lang) {
  getPoiData({
    location: res.data.module1.location,
    radius: res.data.module1.radius,
    bhProType: page15Types,
    polygon: res.data.module1.polygon || "",
    resultLanguage: lang,
  }).then((pageRes) => {
    page15PoiData.value = pageRes?.data.filter((d) => !!d.count) || [];
    setRequestSuccessed("page15");
  }).catch(() => {
    getPoiData({
      location: res.data.module1.location,
      radius: res.data.module1.radius,
      bhProType: page15Types,
      polygon: res.data.module1.polygon || "",
      resultLanguage: lang,
    }).then((pageRes) => {
      page15PoiData.value =
        pageRes?.data.filter((d) => !!d.count) || [];
      setRequestSuccessed("page15");
    }).catch(() => {
      setRequestSuccessed("page15");
    });
  });
}

// page17数据
const page17Types = ["P050301", "P050201", "P050101"];
const page17PoiData = ref([]);
const page17DetailData = ref([]);
function getPage17(res, lang) {
  getPoiData({
    location: res.data.module1.location,
    cityCode: [res.data.module1.district_no],
    bhProType: page17Types,
    // polygon: res.data.module1.polygon || '',
    resultLanguage: lang,
  }).then((res) => {
    page17PoiData.value = res.data || [];
    setRequestSuccessed("page17");
  }).catch(() => {
    getPoiData({
      location: res.data.module1.location,
      radius: res.data.module1.radius,
      bhProType: page17Types,
      // polygon: res.data.module1.polygon || '',
      resultLanguage: lang,
    }).then((res) => {
      page17PoiData.value = res.data || [];
      setRequestSuccessed("page17");
    }).catch(() => {
      setRequestSuccessed("page17");
    });
  });

  // 新 poi 改动
  const sort = ["地铁线路条数", "火车站", "地铁站", "机场"];
  getCityDetailData(address_id).then((res) => {
    page17DetailData.value = sort.map((s) => {
      const item = res?.data?.traffic?.find((t) => t.name === s);
      return item?.value || "--";
    });
  }).catch(() => {
    getCityDetailData(address_id).then((res) => {
      page17DetailData.value = sort.map((s) => {
        const item = res?.data?.traffic?.find((t) => t.name === s);
        return item?.value || "--";
      });
    }).catch(() => {});
  });
}

// 页面已隐藏
const page21Data = ref({});
// 三个页面状态独立
const wrapPage21 = (data) => {
  if (data?.tuijian_qinzi?.length) {
    setRequestSuccessed("page21");
  }
  if (data?.tuijian_canyin?.length) {
    setRequestSuccessed("page22");
  }
  if (data?.tuijian_lingshou?.length) {
    setRequestSuccessed("page23");
  }
};
function getPage21() {
  getBrandData(address_id).then((pageRes) => {
    const { data } = pageRes;
    page21Data.value = data;
    wrapPage21(data);
  }).catch(() => {
    getBrandData(address_id).then((pageRes) => {
      const { data } = pageRes;
      page21Data.value = data;
      wrapPage21(data);
    }).catch(() => {
      console.log("挂了");
      // setRequestSuccessed("page21");
    });
  });
}

// 远方好物数据加载
const initYfhw = () => {
  getBfhwDataById(address_id).then((res) => {
    const { status, data, info } = res
    if (status && data) {
      yfhwTotalData.value = {...data}
    } else {
      console.log('获取远方好物数据失败：', info)
    }
  }).catch((e) => {
    console.log('获取远方好物数据失败')
  })
}

/**
 * 页面渲染完成开始加载数据
 */
const store = useStore();
onMounted(() => {
  if (!address_id) return;
  // 报表数据
  getReport(address_id).then((res) => {
    pageLoading.value = false

    const { status, data, info } = res

    if (!status) {
      isEmptyPage.value = info;
      return false;
    }
    if (data) {
      reportData.value = {
        ...(data || {}),
      };
      const module1 = {
        ...data.module1,
      };
      reportCustomization.value = {
        pageLogo: module1.isUpload ? module1.exclusive_logo : "",
        bottomLogo: module1.exclusive_logo,
        showWater: !module1.watermark_switch,
        showDataSource: !module1.remove_data_source_switch,
      };
      // 远方好物定制需求
      if (module1.isHw) {
        isYFHW.value = true
        diffPageNum.value = 3
        initYfhw()
      }

      // 从接口获取报告语言
      const lang = module1?.reportLanguage || 'zh'
      commonLang.value = lang

      // 缓存基本报告数据
      store.commit("SET_BASIC_REPORT", reportData.value);

      setRequestSuccessed("reportData");
      getPage2(res, lang);
      getPage3(res, lang);
      getPage4(res, lang); // 4 | 5 页用同样的数据
      getPage6(res, lang); // 6 ｜ 7 页用同样的数据
      getPage8(res, lang); // 8 ｜ 9
      getPage10(res, lang);
      getPage12(res, lang);
      getPage13(res, lang);
      getPage14(res, lang);
      getPage15(res, lang);
      getPage17(res, lang);
      getPage21();
    }
  }).catch(() => {
    isEmptyPage.value = '链接失效'
    pageLoading.value = false
  })
});
</script>

<style lang="less">
.container {
  width: 1920px;

  .page-bottom-tips {
    flex-shrink: 0;
    padding: 18px 0;
    text-align: right;
    line-height: 60px;
    font-size: 20px;
    font-weight: 400;
    color: #9a9a9a;

    &.no-gap {
      padding-bottom: 0;
    }
  }
}
.empty-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1920px;
  height: 1080px;
}
.page-box {
  width: 1920px;
  height: 1080px;

  .amap-container {
    position: relative;
  }
  .map-img {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;
  }
}
.report-page {
  .block {
    height: 1080px;
    width: 100%;
  }
  .color-red {
    color: #f40000;
    margin-right: 10px;
  }
  .f-14 {
    font-size: 14px;
  }
  .arrow-up {
    width: 13px;
    height: 13px;
    margin-right: 5px;
    background-image: url("~@/assets/arrow-up.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .arrow-up-color {
    color: #f40000;
  }
  .arrow-down-color {
    color: #05c44b;
  }
  .arrow-down {
    width: 13px;
    height: 13px;
    margin-right: 5px;
    background-image: url("~@/assets/arrow-down.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .etable {
    font-size: 20px;
    .etable-wrapper {
      width: 50%;
    }
    table {
      border-spacing: 1px;
      width: 100%;
      tr.empty-row {
        width: 100%;
        background: #f2f2f2;
        td {
          background: #f2f2f2 !important;
          border-spacing: 0 !important;
        }
      }

      tr {
        td {
          height: 51px;
          background: #dbdbdb;

          font-weight: bold;
          color: #333333;
          line-height: 20px;
          padding-left: 15px;
        }
        td:nth-child(1) {
          text-align: left;
        }
        td:nth-child(2n) {
          text-align: center;
          background: #f2f2f2;
          font-weight: 400;
        }
      }
    }
    .etable-wrapper:nth-child(2) {
      margin-left: -0.5px;
    }
  }
}
</style>
